<template>
  <validation-observer
    ref="infoRules"
    v-slot="{ invalid }"
    tag="form"
  >

    <b-row
      v-if="isLoading"
      class="d-flex justify-content-center"
    >
      <b-spinner
        variant="dark"
        type="grow"
        :style="{ animationDelay: '0.5s' }"
      />
      <b-spinner
        variant="dark"
        type="grow"
        :style="{ animationDelay: '1s' }"
      />
      <b-spinner
        variant="dark"
        type="grow"
        :style="{ animationDelay: '1.5s' }"
      />
    </b-row>
    <b-row v-if="!isLoading">
      <b-col md="6">
        <validation-provider
          #default="validationContext"
          name="issue"
          rules="required"
        >
          <b-form-group
            label="Task"
            label-for="Task"
          >
            <b-form-input
              id="issue"
              v-model="taskForm.issue"
              :state="getValidationState(validationContext)"
              trim
              placeholder="add your task"
            />
            <b-form-invalid-feedback>
              {{ validationContext.errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>
      </b-col>

      <b-col md="6">
        <validation-provider
          #default="validationContext"
          name="assigned to"
          rules="required"
        >
          <b-form-group
            label="Assigned to"
            label-for="Assigned to"
          >
            <v-select
              id="assigned_to"
              v-model="taskForm.assigned_to"
              :options="AssignedToOptions"
              :state="getValidationState(validationContext)"
              trim
              placeholder="Select a person or multiple people to assign"
              multiple
            />
            <b-form-invalid-feedback>
              {{ validationContext.errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>
      </b-col>

      <b-col md="6">
        <validation-provider
          #default="validationContext"
          name="priority"
          rules="required"
        >
          <b-form-group
            label="priority"
            label-for="priority"
          >
            <v-select
              id="priority"
              v-model="taskForm.priority"
              :options="priorityOptions"
              :state="getValidationState(validationContext)"
              trim
              placeholder="choose priority"
            />
            <b-form-invalid-feedback>
              {{ validationContext.errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>
      </b-col>

      <b-col md="6">
        <validation-provider
          #default="validationContext"
          name="required action"
          rules="required"
        >
          <b-form-group
            label="Required Action"
            label-for="Required Action"
          >
            <b-form-input
              id="required_action"
              v-model="taskForm.required_action"
              :state="getValidationState(validationContext)"
              trim
              placeholder="add your required action"
            />
            <b-form-invalid-feedback>
              {{ validationContext.errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>
      </b-col>

      <b-col md="6">
        <validation-provider
          #default="validationContext"
          name="due date"
          rules="required"
        >
          <b-form-group
            label="Due Date"
            label-for="Due Date"
          >
            <b-form-input
              id="due_date"
              v-model="taskForm.due_date"
              type="datetime-local"
              :state="getValidationState(validationContext)"
              trim
              placeholder="due date"
            />
            <b-form-invalid-feedback>
              {{ validationContext.errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>
      </b-col>

      <b-col md="6">
        <b-form-group
          label="Request Number"
          label-for="Request Number"
        >
          <b-form-input
            id="request_id"
            v-model="taskForm.request_id"
            trim
            placeholder="Add Your Request Number (If Any)"
          />
        </b-form-group>
      </b-col>

      <b-col md="12">
        <b-form-group
          label="Attachments"
          label-for="Attachments"
        >
          <b-form-file
            id="attachments"
            v-model="taskForm.attachments"
            multiple
            trim
          />
        </b-form-group>
      </b-col>

      <b-col
        v-if="haveAttatchmentList"
        md="12"
        class="d-flex flex-wrap"
      >
        <div
          v-for="attachment in attatchmentList"
          :key="attachment.id"
          class="mr-3"
        >
          <a
            :href="attachment.url"
            target="_blank"
            style="text-decoration: underline;"
          >
            {{ getFileNameFromUrl(attachment.url) }}
          </a>
          <feather-icon
            icon="Trash2Icon"
            size="20"
            color="red"
            class="ml-2 cursor-pointer"
            @click="deleteAttachment(attachment.id)"
          />
        </div>
      </b-col>

      <b-col md="12">

        <b-form-group
          label="Description"
          label-for="Description"
        >
          <b-form-textarea
            id="description"
            v-model="taskForm.description"
            type="date"
            trim
            placeholder="write your description"
          />
        </b-form-group>
      </b-col>

      <!-- Server Errors -->
      <b-col
        v-if="Object.values(errors).length > 0"
        cols="12"
      >
        <p
          v-for="(error, key, index) in errors"
          :key="index"
          class="text-danger small"
        >
          {{ error.toString() }}
        </p>
      </b-col>
    </b-row>
    <b-row>
      <b-col
        cols="12"
        class="mt-50"
      >

        <b-button
          v-if="!loader && taskId"
          variant="primary"
          class="mr-1"
          :disabled="invalid || Object.values(errors).length > 0"
          @click="addTask()"
        >
          Save Changes
        </b-button>
        <b-button
          v-if="!loader && !taskId"
          variant="primary"
          class="mr-1"
          :disabled="invalid || Object.values(errors).length > 0"
          @click="addTask()"
        >
          Add
        </b-button>
        <b-button
          v-if="loader"
          variant="primary"
          disabled
          class="mr-1"
        >
          <b-spinner
            small
            type="grow"
          />
          Loading...
        </b-button>
      </b-col>
    </b-row>
  </validation-observer>
</template>

<script>
import { ref } from '@vue/composition-api'
import formValidation from '@core/comp-functions/forms/form-validation'
import axios from 'axios'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import VSelect from 'vue-select'

import decryptData from '@/store/auth/decryptData'

// eslint-disable-next-line no-unused-vars

export default {
  components: {
    'v-select': VSelect,
  },
  props: {
    taskId: {
      type: Number,
      required: false,
      default: null, // ✅ Added default value
    },
  },
  data() {
    return {
      id: this.$store.state.generalIds.id,
      required,
      allSelected: [],
      users: [],
      loader: false,
      isLoading: false,
      validationErrors: {},
      errors: {},
      priorityOptions: ['low', 'medium', 'high'],
      haveAttatchmentList: false,
      attatchmentList: [],

    }
  },
  setup() {
    const { getValidationState } = formValidation()
    // eslint-disable-next-line camelcase

    const taskForm = ref({})
    return {
      getValidationState,
      taskForm,
    }
  },

  computed: {
    AssignedToOptions() {
      return this.$store.getters['generalData/assignList/assignList']
    },
  },
  async mounted() {
    this.showTask()

    if (!this.$store.getters['generalData/assignList/assignListLoaded']) {
      await this.$store.dispatch('generalData/assignList/fetchAssignList')
    }
  },

  methods: {
    getFileNameFromUrl(file) {
      if (!file) return ''
      const urlParts = file.split('/')
      return urlParts[urlParts.length - 1]
    },
    deleteAttachment(id) {
      this.$swal({
        title: 'Are you sure?',
        text: "You won't be able to delete this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!',
      }).then(result => {
        if (result.isConfirmed) {
          axios
            .delete(`https://gulftic-system.fci.group/api/task/created/${this.taskId}/delete-file/${id}`)
            .then(() => {
              this.$swal('Deleted!', 'Deleted Successfully.', 'success')
              this.showTask()
            })
            .finally(() => {
              this.loading = false
            })
        }
      })
    },
    async showTask() {
      if (!this.taskId) {
        return false
      }

      this.isLoading = true

      try {
        const response = await axios.get(`https://gulftic-system.fci.group/api/task/${this.taskId}`)
        const getAllData = decryptData(response.data.payload)

        const taskData = getAllData.data

        this.taskForm.issue = taskData.issue
        this.taskForm.priority = taskData.priority
        this.taskForm.due_date = this.formatDate(taskData.due_date)
        this.taskForm.required_action = taskData.required_action
        this.taskForm.description = taskData.description
        this.taskForm.request_id = taskData.request_id || ''

        // Handle attachments
        this.haveAttatchmentList = Array.isArray(taskData.attachments) && taskData.attachments.length > 0
        this.attatchmentList = this.haveAttatchmentList
          ? taskData.attachments.map(item => ({
            id: item.id,
            url: item.url,
          }))
          : []

        // Handle assigned users
        this.taskForm.assigned_to = Array.isArray(taskData.assigned)
          ? taskData.assigned.map(item => ({
            label: `${item.user.name} - ${item.user.email}`,
            value: {
              id: item.user_id,
              type: item.user_type,
            },
          }))
          : []

        return true
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: error.data.message || 'Have an error to get task details',
            icon: 'BellIcon',
            variant: 'error',
          },
        })
      } finally {
        this.isLoading = false
      }
      return false
    },
    formatDate(dateString) {
      const date = new Date(dateString)

      // Extract year, month, day
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')

      // Extract hours and minutes
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')

      return `${year}-${month}-${day}T${hours}:${minutes}`
    },

    async addTask() {
      this.loader = true

      const isUpdate = !!this.taskId
      const formData = new FormData()

      if (isUpdate) {
        formData.append('_method', 'PUT')
      }

      Object.entries(this.taskForm).forEach(([key, value]) => {
        if (key === 'assigned_to' && Array.isArray(value)) {
          value.forEach((item, index) => {
            formData.append(`assigned_to[${index}][id]`, item.value.id)
          })
        } else if (key === 'attachments' && Array.isArray(value)) {
          value.forEach((file, index) => {
            formData.append(`attachments[${index}]`, file)
          })
        } else if (key === 'due_date' && value) {
          // 🔥 Fix format
          const date = new Date(value)
          const formatted = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')} `
      + `${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}:${String(date.getSeconds()).padStart(2, '0')}`
          formData.append(key, formatted)
        } else {
          formData.append(key, value)
        }
      })

      try {
        const url = isUpdate
          ? `https://gulftic-system.fci.group/api/task/${this.taskId}`
          : 'https://gulftic-system.fci.group/api/task'

        const response = await axios.post(url, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })

        const successStatus = isUpdate ? 200 : 201
        if (response.status === successStatus || response.status === 200) {
          if (isUpdate) {
            await this.$store.dispatch('generalData/allTaskManagments/fetchTasks')
            this.$emit('close-modal')
            this.$toasted.show('Updated Successfully', {
              position: 'top-center',
              duration: 3000,
            })
          } else {
            await this.$store.dispatch('generalData/allTaskManagments/fetchTasks')
            this.$emit('close-modal')
            this.$toasted.show('Created Successfully', {
              position: 'top-center',
              duration: 3000,
            })
          }

          // Optional: redirect or callback here
          // this.$router.push({ name: 'Task Management Created' })
        }
      } catch (error) {
        if (error.response?.status && error.response.data?.payload) {
          try {
            const payload = decryptData(error.response.data.payload).message
            const firstArrayKey = Object.keys(payload).find(key => Array.isArray(payload[key]))
            const errorMessage = firstArrayKey ? payload[firstArrayKey][0] : 'An unknown error occurred'

            this.$toast({
              component: ToastificationContent,
              props: {
                title: errorMessage,
                icon: 'BellIcon',
                variant: 'error',
              },
            })
          } catch (e) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Failed to parse error message',
                icon: 'AlertTriangleIcon',
                variant: 'error',
              },
            })
          }
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Unexpected error occurred',
              icon: 'AlertTriangleIcon',
              variant: 'error',
            },
          })
        }
      } finally {
        this.loader = false
      }
    },
  },

}
</script>

    <style lang="scss">
    @import '@core/scss/vue/libs/vue-select.scss';
    </style>
